import React from 'react';
import {connect} from 'react-redux';
import Avatar from '../../accountsetting/Avatar';
import {Link} from 'react-router-dom';

export default React.memo(
  connect(
    state => ({accountSummary: state.components.auth.accountSummary}),
    null
  )(function User({isPartner, accountSummary: {account}}) {
    return (
      <div className="kt-header__topbar-item">
        <div
          className="kt-header__topbar-wrapper pf-header-user-wrapper"
          style={{width: isPartner ? '150px' : ''}}
        >
          <Link to={isPartner ? '/partner/settings' : '/profile-settings'}>
            <div className="pf-header-user-info">
              <Avatar imageUrl={account.imageUrl} width={40} height={40} />
              <span className="pf-header-text kt-visible-desktop pl-2">
                {`${account.firstName} ${account.lastName}`}
              </span>
            </div>
          </Link>
        </div>
      </div>
    );
  })
);
